module.exports = "/images/vendor/flag-icon-css/flags/1x1/ng.svg?520463e155c2f4a38079df87c20a0423";